import React, { memo, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { fetchListProductOptions } from '../actions';
import { SimpleMultiSelectGroupV2 } from '../../../../General/Forms';

const TrainingDateSelect = ({ filterOptions, setFilterOptions, eventProductId }) => {
     const dispatch = useDispatch();

     const [productOptions, setProductOptions] = useState([]);

     const [isLoading, setIsLoading] = useState(false);

     const fetchOrganizationOptions = () => {
          dispatch(fetchListProductOptions(filterOptions, setProductOptions, setIsLoading));
     };

     const onMenuToggle = () => {
          fetchOrganizationOptions();
     };
     const onChangeSelect = (values) => {
          const listProductIds = values.map((item) => item.value);
          const newFilter = { ...filterOptions };
          if (listProductIds.length) {
               newFilter.productIds = listProductIds;
          } else {
               delete newFilter.productIds;
          }
          setFilterOptions(newFilter);
     };

     const newProductOptions =
          eventProductId && eventProductId.length ? productOptions.filter((product) => eventProductId.includes(product.value)) : productOptions;

     return (
          <SimpleMultiSelectGroupV2
               id="user"
               name="filter-product"
               placeholder="Select Product ..."
               className="flex-fill w-100 dropdown-w-100"
               options={newProductOptions}
               isDeleteItem={false}
               values={filterOptions.productIds}
               onChange={onChangeSelect}
               onMenuToggle={onMenuToggle}
               isLoading={isLoading}
          />
     );
};

TrainingDateSelect.propTypes = {
     filterOptions: PropTypes.object,
     setFilterOptions: PropTypes.func,
     eventProductId: PropTypes.oneOfType([PropTypes.array, PropTypes.any]),
};

export default memo(TrainingDateSelect);
